<script>
    import  { Bar }  from 'vue-chartjs';
    export default {
        extends: Bar,
        props: ['data', 'options'],
        data(){
            return {
                localOptions: {
                    maintainAspectRatio: false,
                    legend:{
                        display: false,
                    },
                    tooltips: {
                        bodyFontSize: 16,
                        titleFontSize: 16,
                    },
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontStyle: 'bold',
                                beginAtZero: true,
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                            }
                        }],
                    },
                    label: {
                        fontSize: 20,
                    },

                },
            };
        },
        mounted () {
            var mergedObject = Object.assign({}, this.localOptions, this.options);
            this.renderChart(this.data, mergedObject);
        },
        watch: {
            'data': {
                deep: true,
                handler(data) {
                    let deepEqual = function (x, y) {
                        if (x === y) {
                            return true;
                        }
                        else if ((typeof x == 'object' && x != null) && (typeof y == 'object' && y != null)) {
                            if (Object.keys(x).length !== Object.keys(y).length)
                                return false;

                            for (let prop in x) {
                                if (y.hasOwnProperty(prop))
                                {
                                    if (! deepEqual(x[prop], y[prop]))
                                        return false;
                                }
                                else
                                    return false;
                            }

                            return true;
                        }
                        else
                            return false;
                    };
                    if (!deepEqual(this.data, this.localData)) {
                        this.localData = Object.assign({}, this.data);
                        let mergedObject = Object.assign({}, this.localOptions, this.options);
                        this.renderChart(this.localData, mergedObject);
                    }
                }
            }
        }
    };
</script>